/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locationnotset2Inputs */

const en_locationnotset2 = /** @type {(inputs: Locationnotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location not set`)
};

const de_locationnotset2 = /** @type {(inputs: Locationnotset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort nicht festgelegt`)
};

/**
* | output |
* | --- |
* | "Location not set" |
*
* @param {Locationnotset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const locationnotset2 = /** @type {((inputs?: Locationnotset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locationnotset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locationnotset2(inputs)
	return de_locationnotset2(inputs)
});
export { locationnotset2 as "locationNotSet" }